import React from 'react';
import { Input, OnboardingContainer } from '../../../components';
import { Content, Form, HeaderContainer, Line, Row, StyledButton, Text, Title } from './SetMediaPricePage.styles';
import { Text20Bold } from '../../../components/utils/Text/Text.styles';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useDispatch, useSelector } from 'react-redux';
import { setUserStatus } from '../../../store/slices/user/slice';
import { notifyError } from '../../../utils/notify';
import { setMediaPricing } from '../../../store/slices/influencerRequest/asyncThunks';
import { selectInfluencerRequestActionsPending } from '../../../store/slices/influencerRequest/slice';

const createPricingFormSchema = yup.object({
  photoFrom: yup.number().typeError('Required').required('Required'),
  photoTo: yup
    .number()
    .typeError('Required')
    .required('Required')
    .moreThan(yup.ref('photoFrom'), 'Enter a higher value'),
  videoFrom: yup.number().typeError('Required').required('Required'),
  videoTo: yup
    .number()
    .typeError('Required')
    .required('Required')
    .moreThan(yup.ref('videoFrom'), 'Enter a higher value'),
  bundleFrom: yup.number().typeError('Required').required('Required'),
  bundleTo: yup
    .number()
    .typeError('Required')
    .required('Required')
    .moreThan(yup.ref('bundleFrom'), 'Enter a higher value'),
});

const SetMediaPricePage = () => {
  const dispatch = useDispatch();
  const { setMediaPricing: setMediaPricingPending } = useSelector(selectInfluencerRequestActionsPending);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm({
    defaultValues: {
      photoFrom: '',
      photoTo: '',
      videoFrom: '',
      videoTo: '',
      bundleFrom: '',
      bundleTo: '',
    },
    delayError: 300,
    resolver: yupResolver(createPricingFormSchema),
  });

  const onSubmit = data => {
    const body = {
      pricing: {
        photo: {
          from: data.photoFrom,
          to: data.photoTo,
        },
        video: {
          from: data.videoFrom,
          to: data.videoTo,
        },
        bundle: {
          from: data.bundleFrom,
          to: data.bundleTo,
        },
      },
    };
    dispatch(setMediaPricing(body))
      .unwrap()
      .then(({ userStatus }) => {
        dispatch(setUserStatus(userStatus));
      })
      .catch(e => {
        notifyError(e.message);
      });
  };

  return (
    <OnboardingContainer>
      <Content>
        <HeaderContainer>
          <Text20Bold>Media Price</Text20Bold>
        </HeaderContainer>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Text>
            Enter below the realistic price ranges your media should be sold at. If you already have a paywall, it is
            recommended you follow the same pricing guidelines as there.
          </Text>
          <Title>Photos</Title>
          <Row>
            <Input
              label="Average Range"
              placeholder="From"
              {...register('photoFrom')}
              error={errors.photoFrom?.message}
            />
            <Line />
            <Input label={'\u00A0'} placeholder="To" {...register('photoTo')} error={errors.photoTo?.message} />
          </Row>
          <Title>Videos</Title>
          <Row>
            <Input
              label="Average Range"
              placeholder="From"
              {...register('videoFrom')}
              error={errors.videoFrom?.message}
            />
            <Line />
            <Input label={'\u00A0'} placeholder="To" {...register('videoTo')} error={errors.videoTo?.message} />
          </Row>
          <Title>Bundles</Title>
          <Row>
            <Input
              label="Average Range"
              placeholder="From"
              {...register('bundleFrom')}
              error={errors.bundleFrom?.message}
            />
            <Line />
            <Input label={'\u00A0'} placeholder="To" {...register('bundleTo')} error={errors.bundleTo?.message} />
          </Row>
          <StyledButton title="Continue" isLoading={setMediaPricingPending} />
        </Form>
      </Content>
    </OnboardingContainer>
  );
};

export default SetMediaPricePage;
